function LoadingButton({ onClick, loading }) {
  return (
    <button
      type="button"
      class="btn btn-outline-secondary"
      onClick={() => onClick()}
      disabled={loading}
    >
      Mehr laden
    </button>
  );
}

export default LoadingButton;
